import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineArrowLeft } from 'react-icons/hi2';
import { workPermitService } from '../services';
import PageLoading from '../components/common/PageLoading';
import './Reports.css';

const WorkPermitStatusReport = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadData = async () => {
    try {
      setLoading(true);
      setError('');
      const rows = await workPermitService.getWorkPermits();
      setData(rows || []);
    } catch (err) {
      console.error(err);
      setError('Failed to load permits.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const aggregates = useMemo(() => {
    const statusCounts = {};
    const typeCounts = {};
    data.forEach((p) => {
      statusCounts[p.status] = (statusCounts[p.status] || 0) + 1;
      const type = p.permitTypeName || 'Unspecified';
      typeCounts[type] = (typeCounts[type] || 0) + 1;
    });
    return { statusCounts, typeCounts };
  }, [data]);

  return (
    <div className="pagecontainer reports-page">
      <div className="page-header">
        <div className="header-content">
          <div className="report-title-section">
            <button className="back-btn" onClick={() => navigate("/home/reports")} title="Back to Reports Dashboard">
              <HiOutlineArrowLeft />
            </button>
            <h1>Work Permit Status Report</h1>
          </div>
          <p>Status and type distribution (current data snapshot).</p>
        </div>
        <div className="reports-actions">
          <button className="btn-secondary" onClick={loadData}>Refresh</button>
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}
      {loading ? (
        <PageLoading message="Loading report…" />
      ) : (
        <div className="reports-grid">
          <div className="report-card">
            <h4>By Status</h4>
            <div className="reports-table compact mt-3">
              <table>
                <thead><tr><th>Status</th><th>Count</th></tr></thead>
                <tbody>
                  {Object.keys(aggregates.statusCounts).length === 0 && (
                    <tr><td colSpan="2" className="empty-state">No data</td></tr>
                  )}
                  {Object.entries(aggregates.statusCounts).map(([k, v]) => (
                    <tr key={k}><td>{k}</td><td>{v}</td></tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="report-card">
            <h4>By Permit Type</h4>
            <div className="reports-table compact mt-3">
              <table>
                <thead><tr><th>Type</th><th>Count</th></tr></thead>
                <tbody>
                  {Object.keys(aggregates.typeCounts).length === 0 && (
                    <tr><td colSpan="2" className="empty-state">No data</td></tr>
                  )}
                  {Object.entries(aggregates.typeCounts).map(([k, v]) => (
                    <tr key={k}><td>{k}</td><td>{v}</td></tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkPermitStatusReport;

